import * as React from 'react';
import clsx from 'clsx';
import { jsx as _jsx } from "react/jsx-runtime";
const adjustments = new Map([['3x', {
  size: 12,
  strokeWidth: 1
}], ['4x', {
  size: 16,
  strokeWidth: 1.25
}], ['5x', {
  size: 20,
  strokeWidth: 1.5
}], ['6x', {
  size: 24,
  strokeWidth: 1.5
}]]);
const Icon = /*#__PURE__*/React.forwardRef(Icon_withRef);
function Icon_withRef({
  icon: IconComponent,
  size: sizeProp = 24,
  strokeWidth: strokeWidthProp = 1.5,
  children,
  className,
  ...extraProps
}, ref) {
  const {
    size,
    strokeWidth
  } = typeof sizeProp === 'string' && adjustments.get(sizeProp) || {};
  return /*#__PURE__*/_jsx(IconComponent, {
    ref: ref,
    size: size || sizeProp,
    strokeWidth: strokeWidth || strokeWidthProp,
    className: clsx('Icon', className),
    ...extraProps,
    children: children
  });
}
export { Icon };